import { Heading } from "@/components/Typography"

export function GraphHeader({
	title,
	subtitle,
}: {
	title: string
	subtitle?: string
}) {
	return (
		<>
			<Heading className="text-dark truncate" as="h2" styleAs="h6">
				{title}
			</Heading>
			{subtitle ? (
				<p className="truncate text-xs text-gray-500">{subtitle}</p>
			) : null}
		</>
	)
}

export function GraphHeaderPreloader({ className }: { className?: string }) {
	return (
		<div className={className}>
			<Heading
				className="dummy-text text-dark w-full animate-pulse bg-gray-50"
				as="h2"
				styleAs="h6"
			/>
			<p className="dummy-text w-1/2 animate-pulse bg-gray-50 text-xs text-gray-500" />
		</div>
	)
}
